import { render, staticRenderFns } from "./dingpriceform.vue?vue&type=template&id=fdf6b8b0&scoped=true"
import script from "./dingpriceform.vue?vue&type=script&lang=js"
export * from "./dingpriceform.vue?vue&type=script&lang=js"
import style0 from "./dingpriceform.vue?vue&type=style&index=0&id=fdf6b8b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6b8b0",
  null
  
)

export default component.exports